import formatFileSize from './utils'

const messages = {
  _default: () => `waarde is niet geldig.`,
  after: (field, [target, inclusion]) =>
    `moet na ${
      inclusion ? 'of gelijk aan ' : ''
    }${target}.`,
  alpha_dash: () =>
    `veld kan alfanumerieke tekens alsook streepjes en underscores bevatten.`,
  alpha_num: () => `veld mag alleen alfanumerieke tekens bevatten.`,
  alpha_spaces: () => `veld mag alleen alfabetische tekens en spaties bevatten.`,
  alpha: () => `veld mag alleen alfabetische tekens bevatten.`,
  before: (field, [target, inclusion]) =>
    `moet voor ${
      inclusion ? 'of gelijk aan ' : ''
    }${target}.`,
  between: (field, [min, max]) =>
    `veld moet tussen ${min} en ${max} zijn.`,
  confirmed: () => `bevestiging komt niet overeen.`,
  credit_card: () => `veld is ongeldig.`,
  date_between: (field, [min, max]) =>
    `moet tussen ${min} en ${max} zijn.`,
  date_format: (field, [format]) =>
    `moet in het formaat zijn: ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `het veld moet numeriek zijn en kan ${
      decimals === '*' ? '' : decimals
    } decimale punten.`,
  digits: (field, [length]) =>
    ` veld moet numeriek zijn en precies ${length} cijfers bevatten.`,
  dimensions: (field, [width, height]) =>
    `veld moet ${width} pixels zijn met ${height} pixels.`,
  email: () => `veld moet een geldig e-mail adres zijn.`,
  ext: () => `veld moet een geldig bestand zijn.`,
  image: () => `veld moet een afbeelding zijn.`,
  in: () => `veld moet een geldige waarde zijn.`,
  ip: () => `veld moet een geldig IP-adres zijn.`,
  max: (field, [length]) =>
    `veld mag niet groter zijn dan ${length} tekens.`,
  max_value: (field, [max]) => `veld moet ${max} of minder zijn.`,
  mimes: () => `veld moet een geldig bestandstype hebben.`,
  min: (field, [length]) => `veld moet minimaal ${length} tekens zijn.`,
  min_value: (field, [min]) => `veld moet ${min} of meer zijn.`,
  not_in: () => `veld moet een geldige waarde zijn.`,
  numeric: () => `veld mag alleen numerieke tekens bevatten.`,
  regex: () => `veld format is ongeldig.`,
  required: () => `veld is vereist.`,
  size: (field, [size]) =>
    `de grootte moet kleiner zijn dan  ${formatFileSize(size)}.`,
  url: () => `veld is geen geldige URL.`,
  fullName: () => 'is niet geldig (naam, voornaam en max. 120 tekens)',
  emailInput: () => 'veld moet een geldig e-mail adres zijn.',
  fullNamePerCountry: () => 'is niet geldig (naam, voornaam en max. 18 tekens)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'nl_be',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/nl_be.js